export const settleEn = {
    ruzhuliucheng:"In the process",
    tijiaoziliao:"To disclose the information",
    ziliaoContent:"Wait for the qualification review (1-3 working days) to be approved, and sign the contract by SMS",
    shenqingqianyue:"Apply for signing",
    qianyueContent:"Fill in the company information, upload the business license of the organization, fill in your collection information, facilitate settlement",
    ruzhuchenggong:"In a successful",
    ruzhuContent:"Input information platform audit, audit can be passed business",
    ruzhuyaoqiu:"In requirements",
    zhengshu:"certificate",
    jigouzhengjian:'Agency documents',
    gongsishili:"Company strength",
    womendeyoushi:"Our advantages",
    tybzrz:"General standard certification",
    tyContent:"Industry-wide quality management system solutions",
    jcjgqdndjr:'The testing institution is looking forward to your joining',
    joinNow:"Immediately to join"
}


// WEBPACK FOOTER //
// ./src/lang/home/settle/indexEn.js